<template>
  <div id="datashowtype">
    <div class="typeBlock">
		<p class="title">
			{{$t('datashowtype.dataChartType')}}
		</p>
      <div class="zhu">
		  <img src="../assets/img/zhuxing.png" />
		  <p><el-radio v-model="showType" label="1">{{$t('datashowtype.zhu')}}</el-radio></p>
	  </div>
	  <div class="mei">
		  <img src="../assets/img/meigui.png" />
		  <p><el-radio v-model="showType" label="2">{{$t('datashowtype.mei')}}</el-radio></p>
	  </div>
    </div>
	<div class="ageBlock">
		  <p class="title">
			  {{$t('datashowtype.colorShowType')}}
		  </p>
		  <el-radio v-model="colorShowType" label="0">{{$t('datashowtype.colorShowType_no')}}</el-radio>
		  <el-radio v-model="colorShowType" label="1">{{$t('datashowtype.colorShowType_yes')}}</el-radio>
	  </div>
	<div class="ageBlock">
		  <p class="title">
			  {{$t('datashowtype.ageProject')}}
		  </p>
		  <el-radio v-model="ageType" label="0">{{$t('datashowtype.ageProject_no')}}</el-radio>
		  <el-radio v-model="ageType" label="1">{{$t('datashowtype.ageProject_yes')}}</el-radio>
	  </div>
	<div class="ageBlock" v-if="ageType==0">
		<p class="title">

		</p>
		<el-switch
				v-model="ageMode"
				:active-text="$t('datashowtype.ageMode_yes')"/>
	</div>
	<div class="ageBlock">
	  <p class="title">
		  {{$t('datashowtype.waterProject')}}
	  </p>
	  <el-radio v-model="water_mode" label="0">{{$t('datashowtype.waterProject_no')}}</el-radio>
	  <el-radio v-model="water_mode" label="1">{{$t('datashowtype.waterProject_yes')}}</el-radio>
	</div>

	<div class="typeBlockSubmit">
		<el-button @click="submit" class="btn1 btn_blue_boder" type="primary" size="small">{{$t('datashowtype').sure}}</el-button>
	</div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  name: 'datashowtype',
  data () {
    return {
	  doing: false,
      showType: "1",
	  ageMode: false,
	  initConfs: null,
      ageType: '0',
      colorShowType: '0',
	  water_mode: '-1',
	  platform: null,
		editorOption: {
			theme: "snow",
			modules: {
				toolbar: "#toolbar"
			}
		}
    }
  },
  computed: {
      editor() {
          return this.$refs.myTextEditor.quill;
      }
  },
  created () {
	  this.initConf()
  },
components: {
	quilleditor: quillEditor
},
  methods: {
	submit () {
		if (this.doing === true) {
			return false
		}
        let params = {}
        if(this.showType!=this.initConfs.data_show_type){
            params.data_show_type = this.showType
		}
		let ageModeValue=this.ageMode?1:0
        if(ageModeValue!=this.initConfs.age_mode){
            params.age_mode = ageModeValue
        }
        if(this.ageType!=this.initConfs.age_type){
            params.age_type = this.ageType
        }
		if(this.ageType!=this.initConfs.age_type){
		    params.age_type = this.ageType
		}
        if(this.water_mode != '-1' && this.water_mode!=this.initConfs.water_mode){
            params.water_mode = this.water_mode
        }
        if(Object.keys(params).length==0){
            this.$message(this.$i18n.t('datashowtype').success)
			return
		}
		let dataLoadIng = this.openFullScreen()
		this.doing = true
		let _this = this
		this.axios.post('/skinMgrSrv/config/update', this.formData(params)).then(function (response) {
			_this.doing = false
			if (response.data.code == 0) {
                _this.$message(_this.$i18n.t('datashowtype').success)
			}
			setTimeout(() => {
				dataLoadIng.close()
			}, 300);
		}).catch(function(res){
            _this.doing = false
			console.log(res)
            setTimeout(() => {
                dataLoadIng.close()
            }, 300);
		});
	},
	initConf () {
		if (this.doing === true) {
			return false
		}
		let dataLoadIng = this.openFullScreen()
		this.doing = true
		let _this = this
        let data = {
            code: 'data_show_type,age_mode,age_type,color_show_type,platform,face_bones_content,water_mode'
        };
        this.axios
            .post("/skinMgrSrv/config/get", this.formData(data))
            .then(function(response) {
                _this.doing = false;
                if (response.data.code === 0) {
                    if(response.data.data_show_type){
                        _this.showType = response.data.data_show_type + ''
					}
                    if(response.data.age_type){
                        _this.ageType = response.data.age_type + ''
                    }
                    if(response.data.color_show_type){
                        _this.colorShowType = response.data.color_show_type + ''
                    }
					if(response.data.water_mode || response.data.water_mode === 0 || response.data.water_mode === '0'){
					    _this.water_mode = response.data.water_mode + ''
					}
                    if(response.data.age_mode&&response.data.age_mode==1){
                        _this.ageMode = true
                    }
                    _this.initConfs = Object.freeze(response.data)
                }
                setTimeout(() => {
                    dataLoadIng.close()
                }, 300);
            }).catch(function (res) {
            	_this.doing = false;
                console.error(res)
				setTimeout(() => {
					dataLoadIng.close()
				}, 300);
        });
	}
  }
}
</script>
<style lang="scss">
  #datashowtype{
    width: calc(100% - 40px);
	height: auto;
	background-color: #fff;
	margin: 20px;
	border-radius: 5px;
	padding-top: 60px;
	.typeBlock{
		width: 780px;
		height: 190px;
		margin: 20px 50px;
		display: flex;
		>div{
			width: 210px;
			height: 170px;
			margin: 20px 20px 0 0;
			p{
				text-align: center;
				margin-top: 10px;
			}
		}
		.title {
			width: 230px;
			font-size: 14px;
			vertical-align: center;
			margin: auto 0;
			text-align: right;
			padding-right: 20px;
		}
	}

	  .ageBlock{
		  width: 780px;
		  margin: 20px 0 20px 50px;
		  display: flex;
		  .title {
			  width: 230px;
			  font-size: 14px;
			  vertical-align: center;
			  margin: auto 0;
			  text-align: right;
			  padding-right: 20px;
		  }
		  .el-radio{
			width: 260px;
			margin-right: 10px;
			position: relative;
			top: 4px;
		  }
	  }
	.typeBlockSubmit{
		width: 460px;
		height: 60px;
		text-align: center;
		margin: 60px 80px;
	}
	.btn_blue_boder{
		color: #fff;
	}
  }
</style>



// WEBPACK FOOTER //
// src/config/datashowtype.vue